import Cookies from 'js-cookie'
import axios from 'axios'

// Set a proper fallback API URL instead of relying only on env variables
const API_BASE_URL =
  process.env.NEXT_PUBLIC_API_URL || 'http://127.0.0.1:8000/api/v1/'

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    post: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  },
  timeout: 30000, // 30 second timeout
  timeoutErrorMessage: 'Request timed out. Please try again.'
})

// Log which API URL we're using
// console.log(`Axios client initialized with baseURL: ${client.defaults.baseURL}`)

// You can intercept requests or responses before they are handled by then or catch.
client.interceptors.request.use(
  config => {
    const token = Cookies.get('accessToken')
    if (token) {
      config.headers.common.Authorization = `JWT ${token}`
    }

    // Log full request URL for debugging
    // console.debug(
    //   `API Request: ${config.method?.toUpperCase()} ${config.baseURL}${
    //     config.url
    //   }`
    // )

    return config
  },
  error =>
    Promise.reject(
      (error.response && error.response.data) || 'Something went wrong'
    )
)

// Add response interceptor to handle errors
client.interceptors.response.use(
  response => response,
  error => {
    // Handle response timeout
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      // console.error('Request timeout:', error.config.url)
    }

    // Log API errors in a more structured way
    if (error.response) {
      // console.error(
      //   `API Error ${error.response.status} for ${error.config?.url}:`,
      //   error.response.data || error.message
      // )
    } else if (error.request) {
      // console.error(
      //   `API Request failed for ${error.config?.url}:`,
      //   error.message
      // )
    }

    return Promise.reject(error)
  }
)

export default client
